"use strict";
//  Copyright 2018, Venkat Peri.
//
//  Permission is hereby granted, free of charge, to any person obtaining a
//  copy of this software and associated documentation files (the
//  "Software"), to deal in the Software without restriction, including
//  without limitation the rights to use, copy, modify, merge, publish,
//  distribute, sublicense, and/or sell copies of the Software, and to permit
//  persons to whom the Software is furnished to do so, subject to the
//  following conditions:
//
//  The above copyright notice and this permission notice shall be included
//  in all copies or substantial portions of the Software.
//
//  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
//  OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
//  MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
//  NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
//  DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
//  OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
//  USE OR OTHER DEALINGS IN THE SOFTWARE.
Object.defineProperty(exports, "__esModule", { value: true });
var CallEvent_1 = require("./CallEvent");
exports.CallEvent = CallEvent_1.default;
var CastEvent_1 = require("./CastEvent");
exports.CastEvent = CastEvent_1.default;
var EnterEvent_1 = require("./EnterEvent");
exports.EnterEvent = EnterEvent_1.default;
var Event_1 = require("./Event");
var EventTimeoutEvent_1 = require("./EventTimeoutEvent");
exports.EventTimeoutEvent = EventTimeoutEvent_1.default;
var GenericTimeoutEvent_1 = require("./GenericTimeoutEvent");
exports.GenericTimeoutEvent = GenericTimeoutEvent_1.default;
var InternalEvent_1 = require("./InternalEvent");
exports.InternalEvent = InternalEvent_1.default;
var StateTimeoutEvent_1 = require("./StateTimeoutEvent");
exports.StateTimeoutEvent = StateTimeoutEvent_1.default;
exports.default = Event_1.default;
/**
 * @hidden
 * @param {NextEventAction} action
 * @return {any}
 */
function makeNextEvent(action) {
    switch (action.eventType) {
        case 'internal':
            return new InternalEvent_1.default(action.context);
        case 'cast':
            return new CastEvent_1.default(action.context, action.extra);
    }
    throw new Error("makeNextEvent: Not implemented for " + action.eventType);
}
exports.makeNextEvent = makeNextEvent;
//# sourceMappingURL=index.js.map